module.exports = __webpack_public_path__ + "static/media/image-before.62b1eb7e.png";